import uniq from 'lodash/uniq'

type BaseEntity = {
  id: string
  type: string
  attributes: any
  relationships?: Record<string, { meta?: { included: false }; data?: any }>
}

export const mergeApiEntity = <T extends BaseEntity>(a: T, b: T) => {
  const m = { ...a, ...b }
  const keys = uniq([...Object.keys(a.relationships ?? {}), ...Object.keys(b.relationships ?? {})])
  if (!keys.length) return m
  for (const key of keys) {
    const rels = m.relationships ?? {}
    if (!rels[key]) continue
    if (rels[key].meta?.included === false) {
      const arels = a.relationships ?? {}
      rels[key] = arels[key] ?? rels[key]
      continue
    }
  }
  return m
}

export const mergeApiEntities = <T extends BaseEntity>(a: Record<string, T>, b: Record<string, T>) => {
  const keys = uniq([...Object.keys(a), ...Object.keys(b)])
  const k: Record<string, T> = {}
  for (const key of keys) {
    const aEntity = a[key] ? a[key] : undefined
    const bEntity = b[key] ? b[key] : undefined
    if (!aEntity && bEntity) {
      k[key] = bEntity
    } else if (!bEntity && aEntity) {
      k[key] = aEntity
    }
    if (aEntity && bEntity) {
      k[key] = mergeApiEntity(aEntity, bEntity)
    }
  }
  return k
}
